import devConfig from "./dev.config";
import testConfig from "./test.config.js";
import proConfig from "./pro.config";
let config;

switch (process.env.REACT_APP_ENV) {
  case "development":
    config = devConfig;
    break;
  case "test":
    config = testConfig;
    break;
  case "production":
    config = proConfig;
    break;
  default:
    break;
}
export default config;
